import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { BRAND_ASSETS } from '../../branding';
import './AdminSidebar.css';

// Date d'ajout du menu "Gérer les programmes"; la pastille "Nouveau" s'efface 15 jours après.
const PROGRAMMES_MENU_ADDED_ON = new Date('2026-09-09T00:00:00');
const NEW_BADGE_DURATION_MS = 15 * 24 * 60 * 60 * 1000;

export default function AdminSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuth();

  const isProgrammesMenuNew = Date.now() - PROGRAMMES_MENU_ADDED_ON.getTime() < NEW_BADGE_DURATION_MS;

  const navItems = [
    { label: 'Tableau de bord', path: '/admin', exact: true },
    { label: 'Gérer les rôles', path: '/admin/roles' },
    { label: 'Gérer les utilisateurs', path: '/admin/users' },
    { label: 'Gérer les plans', path: '/admin/plans' },
    { label: 'Gérer les sessions', path: '/admin/sessions' },
    { label: 'Gérer les programmes', path: '/admin/programmes', badge: isProgrammesMenuNew ? 'Nouveau' : null },
    { label: 'Journal d\'activité', path: '/admin/activity' },
  ];

  const isActive = (item) => {
    if (item.exact) {
      return location.pathname === item.path;
    }
    return location.pathname.startsWith(item.path);
  };

  return (
    <aside className="admin-sidebar-clean">
      <div>
        <div className="admin-brand-clean">
          <img className="admin-brand-logo" src={BRAND_ASSETS.logoFull} alt="VeriPlan" />
        </div>
        <div className="admin-brand-sub">Espace administrateur</div>

        <nav className="admin-nav-clean">
          {navItems.map((item) => (
            <button
              key={item.path}
              type="button"
              className={isActive(item) ? 'active' : ''}
              onClick={() => navigate(item.path)}
            >
              {item.label}
              {item.badge && <span className="admin-nav-badge">{item.badge}</span>}
            </button>
          ))}
        </nav>
      </div>

      <div className="admin-user-box">
        <div className="admin-user-name">{user?.nom || 'Administrateur'}</div>
        <button type="button" className="admin-logout-clean" onClick={logout}>
          Déconnexion
        </button>
      </div>
    </aside>
  );
}
